import React from 'react';
import Icon from '../../../components/AppIcon';

const UserStatsCard = ({ stats }) => {
  const StatItem = ({ icon, label, value, trend, trendDirection }) => (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <span className="text-sm font-medium text-muted-foreground">{label}</span>
        </div>
        {trend && (
          <div className={`flex items-center space-x-1 text-xs ${
            trendDirection === 'up' ? 'text-success' : 'text-error'
          }`}>
            <Icon 
              name={trendDirection === 'up' ? 'TrendingUp' : 'TrendingDown'} 
              size={12} 
            />
            <span>{trend}</span>
          </div>
        )}
      </div>
      <div className="text-2xl font-bold text-foreground">{value}</div>
    </div>
  );

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatItem
        icon="Calendar"
        label="Events Attended"
        value={stats?.eventsAttended}
        trend="+3 this month"
        trendDirection="up"
      />
      <StatItem
        icon="Clock"
        label="Upcoming Bookings"
        value={stats?.upcomingBookings}
        trend={null}
        trendDirection={null}
      />
      <StatItem
        icon="DollarSign"
        label="Total Spent"
        value={`$${stats?.totalSpent?.toLocaleString()}`}
        trend="+12% vs last year"
        trendDirection="up"
      />
      <StatItem
        icon="MapPin"
        label="Favorite Venues"
        value={stats?.favoriteVenues}
        trend={null}
        trendDirection={null}
      />
    </div>
  );
};

export default UserStatsCard;